import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column, Typography } from 'seagull';
import styles from './HelpMeWriteOutputRenderer.module.scss';
import { GetHelpMeWriteOutputRendererTID } from './HelpMeWriteOutputRenderer.testIds';
const collapseWhitespace = (text)=>text.replace(/\s+/g, ' ').trim();
export const HelpMeWriteOutputRenderer = (param)=>{
    let { value, testId } = param;
    const { HelpMeWriteOutputRendererTestIds: testIds } = useMemo(()=>GetHelpMeWriteOutputRendererTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 20,
        testId: testIds.Root(),
        children: [
            value.channel === 'email' && /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                weight: "normal",
                className: styles.subjectText,
                testId: testIds.SubjectText(),
                children: collapseWhitespace(value.subject)
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                weight: "light",
                className: styles.messageText,
                testId: testIds.MessageText(),
                children: value.message
            })
        ]
    });
};
